import React from "react"
import { Button } from "@ciq/shared/components/buttons"
import { ReactComponent as CheckIcon } from "@ciq/shared/assets/icons/item_selected_icon.svg"
import { formatTimestamp } from "@ciq/shared/utils/format"

/**
 * @typedef {Object} SuccessBannerProps
 * @property {number|string} timestamp - Epoch timestamp (seconds) or ISO 8601 string when the upload completed
 * @property {Function} onUploadAnother - Callback when user clicks "Upload Another"
 */

/**
 * Success banner displayed after zone data upload completes.
 * Shows confirmation message with timestamp and action buttons.
 *
 * @param {SuccessBannerProps} props
 */
export function SuccessBanner({ timestamp, onUploadAnother }) {
  return (
    <div className="success-banner">
      <div className="success-banner__header">
        <CheckIcon className="success-banner__icon" />
        <h3 className="success-banner__title">Upload Successful</h3>
      </div>
      <p className="success-banner__message">
        Zone data uploaded successfully at {formatTimestamp(timestamp)}
      </p>
      <div className="success-banner__actions">
        <a href="/wireless_config" className="success-banner__link">View in Wireless Config</a>
        <Button variant="success" onClick={onUploadAnother}>
          Upload Another
        </Button>
      </div>
    </div>
  )
}
